<template>
	<div
		class="relative flex flex-col items-center bg-gradient-to-b from-white to-sky-50 min-h-[80px] md:min-h-[335px] overflow-hidden -mb-20 sm:-mb-12 md:-mt-6"
	>
		<div class="mt-4 sm:mt-5 mb-20 sm:mb-18 md:my-auto md:max-w-1/2">
			<h1
				v-if="searchData.paramValues"
				class="relative z-10 text-center font-semibold mx-10 text-xl md:mx-7 md:text-3xl line-clamp-5"
				:title="searchData.paramValues"
			>
				{{ searchData.paramValues }}
			</h1>
			<h1 v-else class="relative z-10 text-center font-semibold px-10 text-3xl md:px-7 md:text-5xl leading-none">
				{{ title }}
			</h1>
			<p
				v-if="searchData.paramValues && !searchData.loading"
				class="relative z-10 max-w-xs my-4 text-dj-gray text-center font-normal text-lg mx-auto md:text-xl md:max-w-3xl"
			>
				<!--{{ $t("hero.subpage.total") }}
					{{searchData.listLength || 0}}
					{{ $t("hero.subpage.found") }}-->
			</p>
			<div
				v-else-if="searchData.paramValues && searchData.loading"
				class="relative flex justify-center z-10 max-w-xs my-4 text-dj-gray text-center font-normal text-lg mx-auto md:text-xl md:max-w-3xl"
			>
				<BaseIcon icon="line-md:loading-twotone-loop" class="text-3xl" color="currentColor" />
			</div>
			<h3
				v-else
				type="h3"
				class="relative z-10 my-4 text-center font-normal text-xl mx-10 md:text-3xl md:max-w-3xl md:mx-auto"
			>
				{{ subtitle }}
			</h3>
		</div>
		<img
			class="md:hidden z-0 absolute left-0 bottom-0"
			src="https://res.cloudinary.com/djbs/image/upload/v1656668226/content/DreamJobs/Graphics/bg_subpagehero-left.svg"
			role="presentation"
			alt=""
		/>
		<img
			class="md:hidden z-0 absolute right-0 bottom-0"
			src="https://res.cloudinary.com/djbs/image/upload/v1656668226/content/DreamJobs/Graphics/bg_subpagehero-right.svg"
			role="presentation"
			alt=""
		/>
		<div
			v-if="globalConfig.isBlue"
			class="hidden md:block z-0 absolute top-0 left-0 bottom-0 right-0 bg-no-repeat bg-[center_top] md:bg-[length:170%] lg:bg-auto bg-[url('https://res.cloudinary.com/djbs/image/upload/v1698223058/content/DreamJobs/Graphics/bg_hero-desktop-blue.svg')]"
		></div>
		<div
			v-else
			class="hidden md:block z-0 absolute top-0 left-0 bottom-0 right-0 bg-no-repeat bg-[center_top] md:bg-[length:170%] lg:bg-auto bg-[url('https://res.cloudinary.com/djbs/image/upload/v1653298940/content/DreamJobs/Graphics/bg_hero-desktop-2.svg')]"
		></div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
	name: "HeroSubpage",
	props: {
		title: {
			type: String,
			default: "",
		},
		subtitle: {
			type: String,
			default: "",
		},
		searchData: {
			type: Object,
			default: {},
		},
	},
	setup() {
		const { locale } = useI18n({
			useScope: "global",
		});

		return {
			locale,
		};
	},
});
</script>
